import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import Home from './components/home/Home';
import LoginPage from './components/login/LoginPage';

function App() {
    const [successfulLogin, setSuccessfulLogin] = useState(false);
    const responseMessage = (response) => {
        console.log(response);
        setSuccessfulLogin(true);
    };
    const errorMessage = (error) => {
        console.log(error);
    };
    return (
        <div>
           <LoginPage />   
        </div>
    )
}
export default App;